import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';

// eslint-disable-next-line react/prop-types
function PaymentItem({ value }) {
  return (
    <div
      style={{
        backgroundColor: 'rgb(229 229 229)',
        padding: '1rem',
        margin: '1rem',
        borderRadius: '1rem',
      }}>
      <Typography fontWeight="bold">{value}</Typography>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export default function PaymentReview({ totalAmountDue }) {
  const {
    events: { event },
  } = useSelector((store) => store);
  const { currentSystemParameters: systemParams } = useSelector((store) => store.systemParameters);
  const [bookingFee, setBookingFee] = useState(0);
  const [cancellFee, setCancellFee] = useState(0);

  useEffect(() => {
    console.log('🍉 current event ', event);
    console.log('🍉 booking_fee_percentage ', event?.booking_fee_percentage);
    console.log('🍉 cancellation_fee_percentage event ', event?.cancellation_fee_percentage);
    const eventBookingFee = parseInt(event?.booking_fee_percentage, 10);
    const eventCancellFee = parseInt(event?.cancellation_fee_percentage, 10);
    if (eventBookingFee !== 0 || eventCancellFee !== 0) {
      console.log('🍉 using custom event fees');
      setBookingFee(eventBookingFee);
      setCancellFee(eventCancellFee);
    } else {
      console.log('🍉 using system fees ', systemParams);
      setBookingFee(parseInt(systemParams?.booking_fee_percentage, 10));
      setCancellFee(parseInt(systemParams?.cancellation_fee_percentage, 10));
    }
  }, [event, systemParams]);

  return (
    <div>
      <Grid container marginTop={4}>
        <Grid item>
          <Typography fontWeight="bold">Payment Review:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>A summary of your charges.</Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        textAlign="center"
        marginBottom={5}>
        <Grid item xs>
          <PaymentItem value={`${bookingFee}%`} />
          <small>the percentage fayVen earns from each event.</small>
        </Grid>
        <Grid item xs>
          <PaymentItem value={`$ ${totalAmountDue} USD`} />
          <small>the total charges you will pay to the venue for this event.</small>
        </Grid>
        <Grid item xs>
          <PaymentItem value={`${cancellFee}% Fee`} />
          <small>
            fayVen will charge you {cancellFee}% of your total payment for a late cancellation.
          </small>
        </Grid>
      </Grid>
    </div>
  );
}
